import React from 'react'
import { Link } from 'react-router-dom'
import Alert from 'components/ui/alert'
import styles from './index.module.css'

type Props = {
  clientLibrariesTrial?: boolean
}

const LibrariesUpgradeAlert = ({
  clientLibrariesTrial,
}: Props): React.ReactElement<'div'> => (
  <div className={styles.librariesUpgradeAlert}>
    <Alert status="info">
      {clientLibrariesTrial && (
        <span>You’re using the trial version of Discovery Suite. </span>
      )}
      <Link className="text-link" to="/settings/billing">
        Subscribe to Discovery Suite
      </Link>{' '}
      <span>
        to publish your Catalogs, invite clients and opt your Catalog in to be
        browsed by Supervisors.
      </span>
    </Alert>
  </div>
)

export default LibrariesUpgradeAlert
